// features/privateInsurance/privateInsurance.slice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { submitPrivateInsuranceFormApi, PrivateInsuranceFormPayload } from './privateInsurance.service';

export const submitPrivateInsuranceForm = createAsyncThunk(
  'privateInsurance/submitPrivateInsuranceForm',
  async (payload: PrivateInsuranceFormPayload, { rejectWithValue }) => {
    try {
      const data = await submitPrivateInsuranceFormApi(payload);
      return data;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error?.message || 'Failed to submit private insurance form';
      return rejectWithValue(errorMessage);
    }
  }
);

type Awaited<T> = T extends Promise<infer U> ? U : T;

type PrivateInsuranceState = {
  message: string | null;
  privateInsuranceData: Awaited<ReturnType<typeof submitPrivateInsuranceFormApi>> | null;
  loading: boolean;
  error: string | null;
};

const initialState: PrivateInsuranceState = {
  message: null,
  privateInsuranceData: null,
  loading: false,
  error: null,
};

const privateInsuranceSlice = createSlice({
  name: 'privateInsurance',
  initialState,
  reducers: {
    clearPrivateInsuranceData: (state) => {
      state.privateInsuranceData = null;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(submitPrivateInsuranceForm.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitPrivateInsuranceForm.fulfilled, (state, action) => {
        state.loading = false;
        state.privateInsuranceData = action.payload;
        state.message = 'Private insurance form submitted successfully!';
      })
      .addCase(submitPrivateInsuranceForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || action.error.message || 'Failed to submit private insurance form';
      });
  },
});

export const { clearPrivateInsuranceData } = privateInsuranceSlice.actions;
export default privateInsuranceSlice.reducer;
